import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactPaginate from 'react-paginate';
import * as DOMPurify from 'dompurify';
import Axios from 'axios';
import { useEffect, useState } from 'react';
import { domain } from '../env';

export const AllBlog = () => {
    const [allblog, setAllblog] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [error, setError] = useState(null);

    // Function to fetch blog data with pagination
    const getAllBlog = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const response = await Axios({
                method: "get",
                url: `${domain}/api/blog/?page=${pageNumber}`
            });
            
            // Handle paginated response
            if (response.data && response.data.results) {
                setAllblog(response.data.results);
                setPageCount(Math.ceil(response.data.count / 6));
                console.log(`Loaded blog page ${pageNumber}, total pages: ${Math.ceil(response.data.count / 6)}`);
            } else {
                console.warn("Response format unexpected:", response.data);
                setAllblog([]);
                setError("Unexpected data format");
            }
        } catch (error) {
            console.error("Error fetching blogs:", error);
            setAllblog([]);
            setError("Failed to load blog data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllBlog();
    }, []);

    const handlePageClick = (event) => {
        const newPage = event.selected + 1;
        setCurrentPage(event.selected);
        getAllBlog(newPage);
        window.scrollTo(0, 600);
    };

    return (
        <>
            <section className="page-header">
                <div className="page-header-bg" style={{'backgroundImage':'url(images/v.jpg)'}}>
                </div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>Blogs</h2>
                        <ul className="thm-breadcrumb list-unstyled">
                            <li><a href="/">Home</a></li>
                            <li><span>/</span></li>
                            <li className="active">BLOGS</li>
                        </ul>
                    </div>
                </div>
            </section>
            
            <section className="blog-page">
                <div className="container">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    ) : (
                        <div className="row">
                            {Array.isArray(allblog) && allblog.length > 0 ? (
                                allblog.map((blog) => (
                                    <div className="col-xl-4 col-lg-4 col-md-6 mb-4" key={blog?.id}>
                                        <div className="blog-one__single">
                                            <div className="blog-one__img" style={{ marginBottom: 0 }}>
                                                <LazyLoadImage 
                                                    effect="blur" 
                                                    src={`${domain}${blog?.image}`}
                                                    alt={blog?.title_English || "Blog Image"}
                                                    style={{
                                                        height: '280px',
                                                        width: '100%',
                                                        objectFit: 'cover',
                                                        display: 'block'
                                                    }}
                                                    placeholder={
                                                        <div style={{height: '280px', backgroundColor: '#f0f0f0'}}></div>
                                                    }
                                                />
                                                <div className="blog-one__date">
                                                    <p>{blog?.date}</p>
                                                </div>
                                                <a href={`/blogdetails${blog?.id}`}>
                                                    <span className="news-one__plus"></span>
                                                </a>
                                            </div>
                                            <div className="blog-one__content" style={{ paddingTop: '15px', marginTop: 0 }}>
                                                <ul className="list-unstyled blog-one__meta">
                                                    <li><a href={`/blogdetails${blog?.id}`}><i className="far fa-user-circle"></i> Admin</a></li>
                                                </ul>
                                                <h3 className="blog-one__title">
                                                    <a href={`/blogdetails${blog?.id}`}>{blog?.title_English}</a>
                                                </h3>
                                                <p className="blog-one__text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(`${blog?.discription_English?.slice(0,100)}...`)}} />
                                                <div className="blog-one__bottom">
                                                    <a href={`/blogdetails${blog?.id}`} className="blog-one__btn">Read More</a>
                                                    <a href={`/blogdetails${blog?.id}`} className="blog-one__arrow"><span className="icon-right-arrow"></span></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center py-5">
                                    <p>No blogs found</p>
                                </div>
                            )}
                        </div>
                    )}
                    
                    {/* Pagination - just centered */}
                    {pageCount > 1 && (
                        <div className="row mt-4">
                            <div className="col-md-12 d-flex justify-content-center">
                                <ReactPaginate
                                    breakLabel="..."
                                    nextLabel={<i className='fas fa-angle-double-right' />}
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={3}
                                    marginPagesDisplayed={1}
                                    pageCount={pageCount}
                                    previousLabel={<i className='fas fa-angle-double-left' />}
                                    renderOnZeroPageCount={null}
                                    containerClassName='pagination'
                                    pageClassName='page-num'
                                    previousLinkClassName="page-num"
                                    nextLinkClassName="page-num"
                                    forcePage={currentPage}
                                    activeLinkClassName="active"
                                />
                            </div>
                        </div>
                    )}
                </div>
            </section>
            <style dangerouslySetInnerHTML={{
                __html: `
                    .blog-one__single {
                        box-shadow: 0 5px 15px rgba(0,0,0,0.05);
                        transition: all 0.3s ease;
                        margin-bottom: 30px;
                    }
                    
                    .blog-one__img {
                        margin-bottom: 0;
                        padding-bottom: 0;
                    }
                    
                    .blog-one__content {
                        padding-top: 15px;
                        margin-top: 0;
                    }
                    
                    .blog-one__img img {
                        width: 100% !important;
                        height: 280px !important;
                        object-fit: cover !important;
                    }
                `
            }} />
        </>
    );
};
